jQuery(function($){
    var galleries = $('.mini-gallery');
    if (!galleries.length) return;
    var items = $('.mini-gallery').find('.wpb_wrapper:first');
    items.addClass('mini-gallery__items');
    items.children().addClass('mini-gallery__item');
    items.after('<div class="mini-gallery__pager"></div>');
    // setup data for pager images
    items.children().each(function(){
        $(this).attr('data-image-url', $(this).find('img').attr('src'));
    });
    setTimeout(function(){
        $('.mini-gallery__items', galleries).cycle({
            fx: 'fadeout',
            slides: '> .mini-gallery__item',
            pager: '+ .mini-gallery__pager',
            pagerTemplate: "<div class='mini-gallery__pager-media'><img class='mini-gallery__pager-media-image' src='{{imageUrl}}' alt=''></div>",
            autoHeight: 'container',
            paused: true
        });
    }, 1);
});
